import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const OnBoarding2: React.FC = () => {
    const [seconds, setSeconds] = useState(10);
    const navigate = useNavigate();

    useEffect(() => {
        // Start countdown timer
        const timer = setInterval(() => {
            setSeconds((prevSeconds) => {
                if (prevSeconds <= 1) {
                    return 0;
                }
                return prevSeconds - 1;
            });
        }, 1000);

        // Cleanup interval on component unmount
        return () => clearInterval(timer);
    }, []);

    // Handle navigation when countdown reaches 0
    useEffect(() => {
        if (seconds === 0) {
            navigate('/app/dashboard');
        }
    }, [seconds, navigate]);

    // Format seconds as MM:SS
    const formatTime = (totalSeconds: number): string => {
        const mins = Math.floor(totalSeconds / 60);
        const secs = totalSeconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <>
            <div className="col-12 col-md-11 col-lg-10 col-xl-7 col-xxl-6">
                <div className="row gx-3 gx-lg-4 h-100 py-3 px-md-3 align-items-center">
                    <div className="col-12">
                        {/* content */}
                        <h1 className="text-theme-1">Thank you!</h1>
                        <h4 className="mb-3 mb-lg-4">Taking you to the Dashboard</h4>
                        <p className="text-secondary mb-3 mb-lg-4">You have done smart selection for your project. You can now customize color scheme, font, sidebar, header style and content styles from our creative customizer from dashboard inner pages. You can skip waiting by <Link to="/app/dashboard" id="redirecttolink">Clicking Here</Link></p>
                        <div className="row gx-3">
                            <div className="col-auto align-self-center">
                                <div className="row gx-3">
                                    <div className="col-auto">
                                        <div className="avatar avatar-50 coverimg rounded-circle">
                                            <img src={asset('assets/img/adminuiux/user-1.jpg')} alt="" id="userimage" />
                                        </div>
                                    </div>
                                    <div className="col ps-0 align-self-center">
                                        <p className="mb-0 text-theme-1" id="usernamedisplay">DevUIUX</p>
                                        <p className="small text-secondary">United States</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col align-self-center">

                            </div>
                            <div className="col-auto">
                                <div className="row gx-3 text-end">
                                    <div className="col align-self-center">
                                        <p className="mb-0"><Link to="/app/dashboard" className="style-none text-theme-1">Please wait</Link></p>
                                        <p className="small text-secondary">Preparing...</p>
                                    </div>
                                    <div className="col-auto align-self-center">
                                        {/* waiting loader */}
                                        <div className="d-block z-index-0 position-relative">
                                            <div className="loader8 d-block mx-auto z-index-0"> </div>
                                            <p className="position-absolute start-50 top-50 translate-middle small text-secondary text-center z-index-1" id="timer">{formatTime(seconds)}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* content ends */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default OnBoarding2;
